const usd0 = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });

/** Finance format: thousands separators, negatives in parentheses, zero as a dash. */
export function money(n: number | null | undefined): string {
  if (n === null || n === undefined || Number.isNaN(n)) return '';
  if (Math.abs(n) < 0.5) return '–';
  const s = usd0.format(Math.abs(n));
  return n < 0 ? `(${s})` : s;
}

export function ratio(n: number | null | undefined, digits = 2): string {
  if (n === null || n === undefined || !Number.isFinite(n)) return 'n/a';
  return `${n.toFixed(digits)}x`;
}

export function periodLabel(period: string): string {
  const [y, m] = period.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, 15)).toLocaleString('en-US', { month: 'short', year: 'numeric', timeZone: 'UTC' });
}

export function dateTimeCentral(iso: string | null | undefined): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('en-US', {
    timeZone: 'America/Chicago',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}
